import React, { memo } from 'react'

import {
  ArrowLeft, ArrowRight, Button, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, shape } from 'prop-types'

import { imageShape } from 'Pods/LazyLoaded/ImageGalleryPanel/imageShape'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { NOOP } from 'Utils/stableDefaults'


import Actions from './Components/Actions/Actions'

const arrowIconSize = { height: '20px', width: '20px' }
// No `color` prop: Triangle's button rule forces the glyph to the button's `currentColor`
// with `!important`, so the arrows are coloured in _image_gallery_modal.scss instead.
const previousIcon = <Icon svgComponent={ArrowLeft} size={arrowIconSize} notSpaced />
const nextIcon = <Icon svgComponent={ArrowRight} size={arrowIconSize} notSpaced />

function Preview({
  image,
  hasPrevious = false,
  hasNext = false,
  onPrevious = NOOP,
  onNext = NOOP,
  onEdit = NOOP,
  onDownload = NOOP,
  onGenerate3d = NOOP,
}) {
  const t = useTranslation()

  return (
    <div className="image-gallery-modal__preview">
      <div className="image-gallery-modal__stage">
        <Button
          type="secondary"
          size="small"
          variant="only-icon"
          actionType="button"
          icon={previousIcon}
          customClass="image-gallery-modal__arrow image-gallery-modal__arrow--previous"
          disabled={!hasPrevious}
          onClick={onPrevious}
          aria-label={t('imageGallery.modal.previous')}
        />
        <img
          className="image-gallery-modal__image"
          src={image.src}
          alt={image.title}
          style={{ '--ratio': image.aspectRatio }}
        />
        <Button
          type="secondary"
          size="small"
          variant="only-icon"
          actionType="button"
          icon={nextIcon}
          customClass="image-gallery-modal__arrow image-gallery-modal__arrow--next"
          disabled={!hasNext}
          onClick={onNext}
          aria-label={t('imageGallery.modal.next')}
        />
      </div>
      <Actions
        title={image.title}
        onEdit={onEdit}
        onDownload={onDownload}
        onGenerate3d={onGenerate3d}
      />
    </div>
  )
}

Preview.propTypes = {
  image: shape(imageShape).isRequired,
  hasPrevious: bool,
  hasNext: bool,
  onPrevious: func,
  onNext: func,
  onEdit: func,
  onDownload: func,
  onGenerate3d: func,
}

export default memo(Preview)
